import React from "react";
import Container from "react-bootstrap/Container";
import Image from "react-bootstrap/Image";
import blankCover from "../../assets/blankCover.jpg";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import ProgressBar from "react-bootstrap/ProgressBar";
import Dropdown from "react-bootstrap/Dropdown";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Spinner from "react-bootstrap/Spinner";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import { loadATitleRequestAction } from "../../redux/actions/appTitles";
import { loadAnIssueRequestAction } from "../../redux/actions/appIssues";
import { withRouter } from "react-router-dom";
import "./IssuePage.css";
import {
  getTextExtractionProgressApi,
  getHTMLifyProgressApi,
  completeApi,
  completeCheckApi,
  downloadEpubApi,
  publishApi,
  publishPubuApi,
  publishFtpApi
} from "../../api/issues";
import ArticleListContainer from "../../components/ArticleListContainer/ArticleListContainer";
import IssueMetaEditor from "../../components/IssueMetaEditor/IssueMetaEditor";
import IssueMediaUploader from "../../components/IssueMediaUploader/IssueMediaUploader";
import { showCopyModalAction } from "../../redux/actions/copyModal";
import CopyModal from "../../components/CopyModal/CopyModal";
import { withCookies } from "react-cookie";
import Badge from "react-bootstrap/Badge";

class IssuePage extends React.Component {
  constructor(props) {
    super(props);
    this.loadIssue = this.loadIssue.bind(this);
    this.openCopyModal = this.openCopyModal.bind(this);
    this.completePressed = this.completePressed.bind(this);
    this.checkPressed = this.checkPressed.bind(this);
    this.inspectPressed = this.inspectPressed.bind(this);
    this.editTocPressed = this.editTocPressed.bind(this);
    this.epubPressed = this.epubPressed.bind(this);
    this.fixedLayoutEpubPressed = this.fixedLayoutEpubPressed.bind(this);
    this.publishPressed = this.publishPressed.bind(this);

    this.state = {
      htmlProgress: 0,
      htmlProgressTotal: 1,
      textProgress: 0,
      textProgressTotal: 1,
      completeLoading: false,
      checkLoading: false,
      epubLoading: false,
      isPublishing: false
    };
  }

  componentDidMount() {
    const { match, history } = this.props;
    const isPdf = match.params.bookType === "pdf_books";

    if (this.props.titleName == null) {
      this.props.loadATitleRequestAction(match.params.titleID, toast, history);
    }

    if (this.props.issueName == null) {
      this.loadIssue();
    }

    if (isPdf) {
      this.getHtmlProgress();
      this.getTextExtractionProgress();
    }
  }

  inspectPressed() {
    const { history, location } = this.props;
    history.push(location.pathname + "/inspect");
  }

  editTocPressed() {
    const { history, location } = this.props;
    history.push(location.pathname + "/toc");
  }

  async publishPressed(type) {
    if (window.confirm("Confirm publishing to " + type + "?") === false) {
      return;
    }

    const { match } = this.props;
    const issueID = match.params.issueID;

    this.setState({ isPublishing: true });

    try {
      if (type === "Pubu") {
        await publishPubuApi(issueID);
      } else if (type === "Ftp") {
        await publishFtpApi(issueID);
      } else {
        await publishApi(issueID);
      }
    } catch (e) {
      toast.error(e.toString());
    }

    this.setState({ isPublishing: false });
  }

  async epubPressed() {
    if (this.state.epubLoading) {
      return;
    }

    this.setState({ epubLoading: true });

    const { match } = this.props;
    const issueID = match.params.issueID;
    const epubLink =
      process.env.REACT_APP_API_ROOT +
      "pdf_books/" +
      issueID +
      "/generate_epub";

    try {
      await downloadEpubApi(issueID, epubLink);
    } catch (e) {
      toast.error(e.toString());
    }

    this.setState({ epubLoading: false });
  }

  async fixedLayoutEpubPressed() {
    if (this.state.epubLoading) {
      return;
    }

    this.setState({ epubLoading: true });

    const { match } = this.props;
    const issueID = match.params.issueID;
    const epubLink =
      process.env.REACT_APP_API_ROOT +
      "pdf_books/" +
      issueID +
      "/generate_fixed_layout_epub";

    try {
      await downloadEpubApi(issueID, epubLink);
    } catch (e) {
      toast.error(e.toString());
    }

    this.setState({ epubLoading: false });
  }

  async completePressed() {
    if (this.state.completeLoading) {
      return;
    }

    this.setState({ completeLoading: true });

    try {
      const { match } = this.props;
      const isPdf = match.params.bookType === "pdf_books";
      const issueID = match.params.issueID;

      await completeApi(isPdf, issueID);
      toast.success("Success");
    } catch (e) {
      toast.error(e.toString());
    }

    this.setState({ completeLoading: false });
  }

  async checkPressed() {
    if (this.state.checkLoading) {
      return;
    }

    this.setState({ checkLoading: true });

    try {
      const { match } = this.props;
      const isPdf = match.params.bookType === "pdf_books";
      const issueID = match.params.issueID;

      await completeCheckApi(isPdf, issueID);
      toast.success("Success");
    } catch (e) {
      toast.error(e.toString());
    }

    this.setState({ checkLoading: false });
  }

  openCopyModal() {
    this.props.showCopyModalAction({ showCopyModal: true });
  }

  loadIssue() {
    const { match, history } = this.props;
    this.props.loadAnIssueRequestAction(
      match.params.issueID,
      match.params.bookType === "pdf_books",
      toast,
      history
    );
  }

  async getHtmlProgress() {
    const { match } = this.props;
    const issueID = match.params.issueID;

    try {
      const data = await getHTMLifyProgressApi(issueID);

      this.setState({
        htmlProgress: data.completed,
        htmlProgressTotal: data.total
      });
    } catch (e) {
      toast.error(e.toString());
    }
  }

  async getTextExtractionProgress() {
    const { match } = this.props;
    const issueID = match.params.issueID;

    try {
      const data = await getTextExtractionProgressApi(issueID);

      this.setState({
        textProgress: data.completed,
        textProgressTotal: data.total
      });
    } catch (e) {
      toast.error(e.toString());
    }
  }

  render() {
    const { match, issue, cookies, title } = this.props;
    const meTitleLink = `${process.env.REACT_APP_URL_ROOT}titles/${
      match.params.titleID
    }/pdf_books`;
    const titleName = this.props.titleName != null ? this.props.titleName : "";

    const meLink = `${process.env.REACT_APP_URL_ROOT}titles/${
      match.params.titleID
    }/${match.params.bookType}/${match.params.issueID}`;
    const issueName = issue != null ? issue.issue : "";

    const isPdf = match.params.bookType === "pdf_books";

    const titleAutomate = title != null ? title.automate : 0;
    const issueCoverID = issue != null ? issue.cover.id : null;
    const issueCover =
      issueCoverID == null
        ? blankCover
        : `${
            process.env.REACT_APP_API_ROOT
          }artworks/${issueCoverID}/static/thumbnail`;

    const textPercent =
      (this.state.textProgress * 100) / this.state.textProgressTotal;
    const htmlPercent =
      (this.state.htmlProgress * 100) / this.state.htmlProgressTotal;

    const isAdmin = cookies.get("role") === "admin";
    const coverUri =
      issueCoverID != null
        ? `${process.env.REACT_APP_API_ROOT}artworks/${issueCoverID}/static`
        : null;

    return (
      <React.Fragment>
        {isAdmin && isPdf && (
          <CopyModal isPdf={isPdf} issueID={match.params.issueID} />
        )}
        <Container>
          <Row>
            <Col>
              <Breadcrumb active="true" className="path_container">
                <Breadcrumb.Item href={process.env.REACT_APP_URL_ROOT}>
                  Home
                </Breadcrumb.Item>
                <Breadcrumb.Item href={meTitleLink}>
                  {titleName}
                  {titleAutomate >= 1 && (
                    <Badge
                      variant="warning"
                      className="title_list_item_auto_badge"
                    >
                      {titleAutomate >= 2 ? "Fit Reading" : "TOC"}
                    </Badge>
                  )}
                </Breadcrumb.Item>
                <Breadcrumb.Item href={meLink}>{issueName}</Breadcrumb.Item>
              </Breadcrumb>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={12} md={3} lg={3} xl={3}>
              <a href={coverUri} target="_blank" rel="noopener noreferrer">
                <Image src={issueCover} className="left_cover_image" />
              </a>
              {isPdf && (
                <React.Fragment>
                  <ProgressBar
                    className="issue_page_progress"
                    variant="info"
                    now={textPercent}
                    label={`Text Extraction ${this.state.textProgress}/${
                      this.state.textProgressTotal
                    }`}
                  />
                  <ProgressBar
                    className="issue_page_progress"
                    variant="info"
                    now={htmlPercent}
                    label={`HTMLify ${this.state.htmlProgress}/${
                      this.state.htmlProgressTotal
                    }`}
                  />
                </React.Fragment>
              )}
              <Button
                block
                size="lg"
                className="issue_page_btns"
                variant="success"
                disabled={this.state.completeLoading}
                onClick={this.completePressed}
              >
                {this.state.completeLoading ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  "Complete"
                )}
              </Button>
              {
                <Button
                  block
                  size="lg"
                  className="issue_page_btns"
                  variant="info"
                  onClick={this.editTocPressed}
                >
                  Edit TOC
                </Button>
              }
              {isAdmin && isPdf && (
                <Button
                  block
                  size="lg"
                  className="issue_page_btns"
                  variant="info"
                  onClick={this.inspectPressed}
                >
                  Inspect HTML5
                </Button>
              )}
              {isAdmin && (
                <Button
                  block
                  size="lg"
                  className="issue_page_btns"
                  variant="success"
                  disabled={this.state.checkLoading}
                  onClick={this.checkPressed}
                >
                  {this.state.checkLoading ? (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : (
                    "Complete Checking"
                  )}
                </Button>
              )}
              {isAdmin && (
                <Dropdown drop="right">
                  <Dropdown.Toggle
                    block
                    size="lg"
                    variant="danger"
                    id="dropdown-basic"
                    className="issue_page_dropdown"
                  >
                    {this.state.isPublishing ? (
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      "Publish"
                    )}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item
                      disabled={this.state.isPublishing}
                      as="button"
                      onClick={() => this.publishPressed("Kono")}
                    >
                      Kono
                    </Dropdown.Item>
                    {isPdf &&
                      issue != null &&
                      issue.pubu_product_id != null &&
                      issue.pubu_product_category != null && (
                        <Dropdown.Item
                          disabled={this.state.isPublishing}
                          as="button"
                          onClick={() => this.publishPressed("Pubu")}
                        >
                          Pubu
                        </Dropdown.Item>
                      )}
                    {isPdf && process.env.REACT_APP_REGION === "JP" && (
                      <Dropdown.Item
                        disabled={this.state.isPublishing}
                        as="button"
                        onClick={() => this.publishPressed("Ftp")}
                      >
                        FTP
                      </Dropdown.Item>
                    )}
                  </Dropdown.Menu>
                </Dropdown>
              )}
              {isAdmin && isPdf && (
                <Button
                  block
                  size="lg"
                  className="issue_page_btns"
                  variant="outline-dark"
                  onClick={this.openCopyModal}
                >
                  Copy
                </Button>
              )}
              {isAdmin && isPdf && (
                <Dropdown drop="right">
                  <Dropdown.Toggle
                    block
                    size="lg"
                    variant="outline-dark"
                    id="dropdown-basic"
                    disabled={this.state.epubLoading}
                    className="issue_page_dropdown"
                  >
                    {this.state.epubLoading ? (
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      "Download Epub"
                    )}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item as="button" onClick={this.epubPressed}>
                      Reflowable
                    </Dropdown.Item>
                    <Dropdown.Item
                      as="button"
                      onClick={this.fixedLayoutEpubPressed}
                    >
                      Fixed-layout
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              )}
            </Col>
            <Col xs={12} sm={12} md={9} lg={9} xl={9}>
              <Tabs defaultActiveKey="articles" transition={false}>
                <Tab eventKey="articles" title="Articles">
                  <ArticleListContainer
                    isAdmin={isAdmin}
                    isPdf={isPdf}
                    issueID={match.params.issueID}
                    editTocPressed={this.editTocPressed}
                  />
                </Tab>
                {isAdmin && (
                  <Tab eventKey="meta" title="Book metadata">
                    {issue && (
                      <IssueMetaEditor
                        issue={issue}
                        loadIssue={this.loadIssue}
                        isPdf={isPdf}
                      />
                    )}
                  </Tab>
                )}
                {isAdmin && (
                  <Tab eventKey="media" title="Audio/Video">
                    <IssueMediaUploader
                      issueID={match.params.issueID}
                      isPdf={isPdf}
                    />
                  </Tab>
                )}
              </Tabs>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

const mapState = (state, ownProps) => {
  const { appTitles, appIssues } = state;
  const { match } = ownProps;

  const titleName =
    appTitles[match.params.titleID] == null
      ? null
      : appTitles[match.params.titleID].name;

  return {
    titleName,
    issue: appIssues[match.params.issueID],
    title: appTitles[match.params.titleID]
  };
};

const mapDispatch = {
  loadATitleRequestAction,
  loadAnIssueRequestAction,
  showCopyModalAction
};

export default withCookies(
  connect(
    mapState,
    mapDispatch
  )(withRouter(IssuePage))
);
